// extracted by mini-css-extract-plugin
export const mainSection = "contactUs-module--mainSection--3Qqfi";
export const contentWrap = "contactUs-module--contentWrap--Ar5yB";
export const content = "contactUs-module--content--1qrx3";
export const wrapper = "contactUs-module--wrapper--jSBmw";
export const footer_contact_info = "contactUs-module--footer_contact_info--uLM6f";
export const componentWrapper = "contactUs-module--componentWrapper--1eavc";